import PropertyModal from "./PropertyModal"

export default PropertyModal
